import { render, staticRenderFns } from "./HireForJob.vue?vue&type=template&id=66b2880e&scoped=true&"
import script from "./HireForJob.vue?vue&type=script&lang=js&"
export * from "./HireForJob.vue?vue&type=script&lang=js&"
import style0 from "./HireForJob.vue?vue&type=style&index=0&id=66b2880e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b2880e",
  null
  
)

export default component.exports